// src/components/ui/Button.jsx
import styles from "./Button.module.css";

export default function Button({
  children, variant = "primary", size, fullWidth, loading, disabled, onClick, type = "button", ...rest
}) {
  const cls = [
    styles.btn,
    styles[variant] || styles.primary,
    size && styles[size],
    fullWidth && styles.full,
    loading && styles.loading,
  ].filter(Boolean).join(" ");

  return (
    <button type={type} className={cls} disabled={disabled || loading} onClick={onClick} {...rest}>
      {loading ? "Loading…" : children}
    </button>
  );
}
